var array = Array.prototype;

export var slice = array.slice;
export var map = array.map;



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-array/src/array.js
// module id = ../../../../d3-array/src/array.js
// module chunks = vendor